__turbopack_context__.v({
  "DescriptionClass": "VQdpmG_DescriptionClass",
});
